import { useState } from "react";
import styles from "../components.module.sass";

const BAR_HEIGHTS = [10, 15, 20, 25, 30];
const ACTIVE_COLOR = "rgb(251, 171, 53)";
const HOVER_COLOR = "rgba(251, 171, 53, 0.75)";
const INACTIVE_COLOR = "#d0d0d0";

interface Props {
  value: number;
  onChange: (value: number) => void;
}

export const SizeScaleSelector = ({ value, onChange }: Props) => {
  const [hovered, setHovered] = useState<number | null>(null);

  const getColor = (barValue: number): string => {
    const displayValue = hovered ?? value;
    if (barValue <= displayValue) {
      return (hovered !== null && barValue > value) ? HOVER_COLOR : ACTIVE_COLOR;
    }
    return INACTIVE_COLOR;
  };

  return (
    <div
      className={styles.sizeScaleSelector}
      role="group"
      aria-label="Size scale"
    >
      {BAR_HEIGHTS.map((height, i) => {
        const barValue = i + 1;
        return (
          <div
            key={barValue}
            role="button"
            aria-label={`Size ${barValue}`}
            tabIndex={0}
            style={{
              width: 10,
              height,
              backgroundColor: getColor(barValue),
              cursor: "pointer",
              borderRadius: 2,
              transition: "background-color 0.15s ease",
            }}
            onClick={() => onChange(barValue)}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                onChange(barValue);
              }
            }}
            onMouseEnter={() => setHovered(barValue)}
            onMouseLeave={() => setHovered(null)}
          />
        );
      })}
    </div>
  );
};
